import { useState } from 'react';
import { v4 as uuid4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { PATH } from '../../constants';
import { userProfileData as defaultProfiles } from '../../test.data';
import { UserProfile } from '../../types/userProfile';
import { itemsBetween, searchForValue } from '../../utils/common.util';
import Container from '../containers/container';
import ExpandedSearchContainer from '../containers/expanded-search.container';
import SearchInput from '../form/search-input';
import { VStack } from '../layouts/stack.layout';
import LinkingContainer from '../link/linking-container';
import { IconTextGroup } from '../typography/v2/icon-text-group';
import Text from '../typography/v2/text';

const styles = {
  container: 'relative w-full',
  'search-container':
    'absolute z-40 bg-dark-gray w-full rounded-lg overflow-hidden',
};

type Props<T> = {
  query?: string;
  searchSpace?: Array<T>;
};

export default function Search<T>(props: Props<T>) {
  const [searchValue, setSearchValue] = useState<string>('');
  const navigate = useNavigate();

  // temporary since we aren't doing a query
  const results = itemsBetween(
    defaultProfiles,
    searchForValue(
      searchValue,
      defaultProfiles.map((profile: UserProfile) => ({
        title: profile.username,
        id: profile.username,
      }))
    ),
    'username'
  );

  const reset = () => {
    setSearchValue(() => '');
  };

  return (
    <div className={styles.container}>
      <form onSubmit={() => navigate(`/${PATH.DISCOVER}?q=${searchValue}`)}>
        {/** Start transition might be helpful when we are actually querying db */}
        {/** Memoization will be helpful when we are actually querying db */}
        <SearchInput
          value={searchValue}
          set={setSearchValue}
          placeholder="Search"
        />
      </form>
      {searchValue && (
        <Container extensions={styles['search-container']}>
          <Container>
            <VStack gap="xs">
              {(!results || !results.length) && (
                <ExpandedSearchContainer value={searchValue} />
              )}

              {results.map((result: any) => (
                <LinkingContainer
                  key={uuid4()}
                  onClick={reset}
                  path={`/${result.username}`}
                  image={{
                    alt: result.username,
                    url: result.avatarUrl,
                  }}
                >
                  <VStack>
                    <IconTextGroup
                      icon="verified"
                      gap="xs"
                      variant="username"
                      iconColor="quartiary"
                      text={result.displayName}
                    />
                    <Text variant="supplementary">@{result.username}</Text>
                  </VStack>
                </LinkingContainer>
              ))}
            </VStack>
          </Container>
        </Container>
      )}
    </div>
  );
}
